module.exports = __webpack_public_path__ + "img/signup.4546ea1f.svg";